export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/680273bf09bfd3a8fc34474ae0d0eb37.svg";